<template>
	<table class="table table--small">
		<thead>
			<tr>
				<th class="text-left">Description</th>
				<th class="text-right">Value</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="detail in details"
				:key="detail.id">
				<td>{{ detail.description || '-' }}</td>
				<td class="text-right">
					<mutation-value :data="detail" />
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import MutationValue from '@/components/MutationValue.vue';

export default {
	name: 'WalletHistoryDetails',
	props: {
		details: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		MutationValue,
	},
};
</script>
